module.exports = __webpack_public_path__ + "img/mission.a7c532e3.svg";